import queryString from 'query-string'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Field, Form, getFormValues, reduxForm } from 'redux-form'

import { Button, FormHelperText, Grid, Paper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import ErrorMessage from '../../components/ErrorMessage'
import withInit from '../../components/containers/withInit'
import loginFields from '../../config/login-fields'
import validationService from '../../services/validation-service'
import { loginCapture, useLocalStorage } from '../../utils/helpers'
import { signInValidationSchema } from '../../utils/validationSchema'
import styles from './SignInCaptureStyles'

const useStyles = makeStyles(styles)

const SignInCapture = props => {
  const classes = useStyles()
  const { t } = useTranslation('pageText')
  const [showPassword, setShowPassword] = useState(false)
  const [, setLatestEmail] = useLocalStorage('latestEmailInput', '')

  const location = useLocation()

  const {
    formValues,
    error,
    handleSubmit,
    asyncValidating,
    pristine,
    valid,   
    localisation,
    submitting,
    setIsSubmitting,
    isSubmitting,
  } = props

  const submitDisabled = !!(pristine || !valid || asyncValidating)
  const qs = queryString.parse(location.search)

  const rtMapper = {
    '2': {
      message: 'Your password has been reset!',
      paperClassName: 'passwordReset',
      textClassName: 'passwordResetMessage',
    },
    '3': {
      message: 'Your session has timed out. Please log in again.',
      paperClassName: 'errorMessage',
      textClassName: 'errorHelper',
    },
  }

  const hasQueryRT = qs.rt || undefined

  const RTMessage = ({ message, paperClassName, textClassName }) => (
    <Grid container>
      <Grid item container md={12} sm={12} xs={12}>
        <Paper elevation={0} className={classes[paperClassName]}>
          <FormHelperText className={classes[textClassName]}>{message}</FormHelperText>
        </Paper>
      </Grid>
    </Grid>
  )

  useEffect(() => {
    if (formValues && formValues.hasOwnProperty('email')) setLatestEmail(formValues.email)
  }, [formValues, setLatestEmail])

  useEffect(() => {
    document.title = t('pageTitle')
  }, [t])

  useEffect(() => {
    if (submitting) {
      setIsSubmitting(true)
    }
  }, [submitting, setIsSubmitting])

  useEffect(() => {
    if (error) setIsSubmitting(false)
  }, [error, setIsSubmitting])

  const fields = loginFields(localisation.pageText)
  return (
    <>
      <Typography component="h3" variant="h5" color="primary" className={classes.title}>
        Log In
      </Typography>

      {/* 
      <AzureAuthenticationButton
        className={classes.msButton}
        buttonText='Sign in with Microsoft'
      /> 

      <div className={classes.separator} />
      */}

      <Form className={classes.form} onSubmit={handleSubmit}>
        {hasQueryRT && <RTMessage {...rtMapper[qs.rt]} />}
        <Grid container spacing={2}>
          <Grid item md={12} sm={12} xs={12}>
            <Field {...fields.email} disabled={isSubmitting} />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Field
              {...fields.password}
              showPassword={showPassword}
              setShowPassword={setShowPassword}
              disabled={isSubmitting}
            />
          </Grid>
          <ErrorMessage error={error} />

          <Grid item container md={12} sm={12} xs={12}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              color="primary"
              className={classes.submit}
              disabled={submitDisabled || isSubmitting}
            >
              {t('loginButton')}
            </Button>
          </Grid>

          <Grid container item md={12} xs={12} direction="row" justifyContent="space-between" alignItems="center">
            <Field {...fields.rememberMe}>{t('rememberMe')}</Field>
            {/* <Link href={`/forgottenPassword/${partnerId}`}>{t('forgottenPasswordPrompt')}</Link> */}
          </Grid>
        </Grid>
      </Form>
    </>
  )
}

const ReduxSignInCapture = reduxForm({
  form: 'signInCapture',
  validate: validationService.syncValidation(signInValidationSchema),
  onSubmit: loginCapture,
  enableReinitialize: true,
})(SignInCapture)

const mapStateToProps = state => {
  const {
    form: { SignInCapture },
  } = state

  const initialValues = {
    email: localStorage.getItem('username') || '',
  }

  return {
    formValues: getFormValues('signInCapture')(state),
    SignInCapture,
    initialValues,
  }
}

const connectedSignInCapture = connect(mapStateToProps)(ReduxSignInCapture)

export default withInit(connectedSignInCapture)
